<p-confirmDialog [closable]="false" [key]="dialogKey" [baseZIndex]="1000"></p-confirmDialog>
<div *ngIf="isPageReady" class="flex flex-col h-full">
  <div class="qb-content-card flex-1 flex flex-col overflow-hidden">
    <div class="qb-detail-card w-full">
      <div class="flex flex-col gap-3">
        <!-- Product Type Info Panel (read-only) -->
        <div class="qb-info-panel rounded-md p-3 mb-2">
          <div class="flex items-center gap-3 mb-2">
            <h6 class="m-0 font-semibold">Product Type</h6>
            <button
              *ngIf="isAdding"
              pButton
              type="button"
              class="p-button-raised p-button-sm"
              icon="pi pi-search"
              (click)="selectProductType()"
            >
              <span>Select</span>
            </button>
          </div>
          <table class="w-full border-collapse">
            <tr>
              <td class="font-semibold pr-3 py-1 w-32">Manufacturer</td>
              <td class="py-1">{{ mptConfig.productType?.manufacturer?.name }}</td>
            </tr>
            <tr>
              <td class="font-semibold pr-3 py-1">SKU</td>
              <td class="py-1">{{ mptConfig.productType?.style }}</td>
            </tr>
            <tr>
              <td class="font-semibold pr-3 py-1">Description</td>
              <td class="py-1">{{ mptConfig.productType?.description }}</td>
            </tr>
          </table>
        </div>

        <!-- Row 1: Config Name (6) + For Stock Orders Only Checkbox (6) -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Manufacturer's Configuration Name" class="col-span-8" [forceShowErrors]="showAllErrors">
            <input
              #firstInput
              pInputText
              [(ngModel)]="mptConfig.configName"
              [bzModel]="mptConfig"
              name="configName"
              title="Manufacturer's Config Name"
            />
          </qb-field>
          <div class="col-span-3">
            <div class="flex items-center gap-2 mt-10">
              <p-checkbox
                inputId="isForStockOrdersOnly"
                [(ngModel)]="mptConfig.isForStockOrdersOnly"
                [bzModel]="mptConfig"
                name="isForStockOrdersOnly"
                [binary]="true"
              ></p-checkbox>
              <label for="isForStockOrdersOnly">For Stock Orders Only</label>
            </div>
          </div>
        </div>

        <!-- Row 2: Config Description + Status -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Manufacturer's Configuration Description" class="col-span-8" [forceShowErrors]="showAllErrors">
            <input
              pInputText
              [(ngModel)]="mptConfig.configDescription"
              [bzModel]="mptConfig"
              name="configDescription"
              title="Manufacturer's Config Description"
            />
          </qb-field>

          <qb-field label="Status" class="col-span-3" [forceShowErrors]="showAllErrors">
            <p-dropdown
              [options]="activeStatuses"
              [(ngModel)]="mptConfig.activeStatusId"
              [bzModel]="mptConfig"
              name="activeStatusId"
              optionValue="id"
              optionLabel="name"
            />
          </qb-field>
        </div>
      </div>
    </div>

    <!-- Addons Section -->
    <div class="qb-child-actions mt-3">
      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-link" (click)="attachAddon()">
        <span>Attach Add-On</span>
      </button>
    </div>
    <app-ag-grid [gridOptions]="mptcAddonGridOptions" [rowData]="mptcAddons" class="flex-1 min-h-0"></app-ag-grid>
  </div>

  <div class="flex flex-row gap-2 justify-start mt-4">
    <button
      [disabled]="!this.uow.hasChanges()"
      (click)="ok()"
      pButton
      type="button"
      label="Ok"
      title="Ok"
      icon="pi pi-check"
      class="p-button-raised"
    ></button>
    <button (click)="cancel()" pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times" class="p-button-raised"></button>
  </div>
</div>
